<div class="flex items-center justify-center w-16 h-16 rounded-lg" [ngClass]="'bg-' + color + '-light'">
  <div [ngClass]="'text-' + color">
    <div
      [class]="stroke ? 'fill-' + color + ' ' + 'stroke-' + color : 'fill-current'"
      [ngClass]="width ? width : 'w-7.5'"
      [inlineSVG]="'./assets/icons/' + icon"
    ></div>
  </div>
</div>
